/* Client feature flags (nav-ia-008).
   ════════════════════════════════════════════════════════════════
   `nav_v2` gates the redesigned role-aware sidebar (SidebarV2). Default OFF.
   Resolution order:
     1. localStorage  es-ff-nav-v2 = "1"  — per-browser QA override (forces ON,
        e.g. to show specific beta testers before the global flip).
     2. DB-backed global flag — `user.feature_flags.nav_v2`, set from the Admin
        Settings UI (system_settings.feature_flags) and served on /auth/me.
     3. build env     REACT_APP_NAV_V2 = "1" | "true"  — local-dev fallback only.
   Pass the authenticated `user` (from AuthContext) so source 2 is consulted. */

export function isNavV2Enabled(user) {
  // 1. Per-browser QA override.
  try {
    if (typeof window !== "undefined" && window.localStorage.getItem("es-ff-nav-v2") === "1") {
      return true;
    }
  } catch {
    /* storage unavailable — fall through */
  }
  // 2. DB-backed global flag (the production switch).
  if (user?.feature_flags?.nav_v2 === true) return true;
  // 3. Build-env fallback (local dev).
  const env = process.env.REACT_APP_NAV_V2;
  return env === "1" || env === "true";
}
